import React from 'react';
import {Grid, Typography} from '@material-ui/core';

const SearchBoxMessage = ({className = '', message}) => (
  <Grid container justify="center" alignItems="center" className={className}>
    <Typography color="secondary" component="p" variant="body2">{message}</Typography>
  </Grid>
);

export default SearchBoxMessage;